import React, { ReactElement, useCallback, useState } from 'react'
import { debounce } from 'lodash'

type Props = {
    value: number
    onChange: (value: number) => void
    label: string
    children?: any
    minValueAllowed?: number
    maxValueAllowed?: number
    className?: string
}

export default function NumericField(props: Props): ReactElement {
    const [value, setValue] = useState(props.value)

    const handleOnChange = (value: number): void => {
        setValue(value)
        onChange(value)
    }

    const onChange = useCallback(
        debounce(x => props.onChange(x), 1000),
        []
    )

    return (
        <div className="input-config">
            <label>{props.label}</label>
            <div className="input-field">
                <input
                    className={props.className}
                    type="number"
                    placeholder="auto"
                    min={props?.minValueAllowed}
                    max={props?.maxValueAllowed}
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(+e.target.value)}
                />
                {props.children}
            </div>
        </div>
    )
}
